export default __webpack_public_path__ + "static/O0237-485ea38474ccd122bcc5544b59998731.png";